import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'

const FaqItemSchema = buildEntrySchemaFor('faqItem', {
  fields: z.lazy(() =>
    z.object({
      question: z.string(),
      answer: RichTextSchema,
    }),
  ),
})

export const FaqGroupSchema = buildEntrySchemaFor('faqGroup', {
  fields: z.lazy(() =>
    z.object({
      heading: safeOptional(RichTextSchema),
      faqs: z.array(FaqItemSchema),
    }),
  ),
})

export type FaqGroup = z.infer<typeof FaqGroupSchema>
